
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useHiringProcess } from "@/hooks/hiring/useHiringProcess";

// Import necessary subcomponents
import HiringHeader from "./hiring/HiringHeader";
import HiringProgress from "./hiring/HiringProgress";
import StageRenderer from "./hiring/StageRenderer";
import NavigationButtons from "./hiring/NavigationButtons";
import { Card } from "./ui/card";

interface HiringProcessProps {
  initialCandidateId?: number | null;
}

export const HiringProcess: React.FC<HiringProcessProps> = ({ initialCandidateId = null }) => {
  const { 
    currentStage, 
    progress, 
    isSubmitting, 
    aiStaff, 
    selectedCandidate, 
    hiringStages,
    handleNextStage, 
    handlePreviousStage, 
    handleSelectCandidate, 
    handleComplete
  } = useHiringProcess();

  // Set the initial candidate when the component mounts if provided
  useEffect(() => {
    if (initialCandidateId !== null) {
      handleSelectCandidate(initialCandidateId);
    }
  }, [initialCandidateId, handleSelectCandidate]);
  
  return (
    <div className="max-w-4xl mx-auto py-8 px-4 animate-fade-in">
      <HiringHeader />
      
      <HiringProgress 
        hiringStages={hiringStages}
        currentStage={currentStage}
        progress={progress}
      />
      
      <Card className="glass-card p-6 transition-all duration-300">
        <StageRenderer
          currentStage={currentStage}
          selectedCandidate={selectedCandidate}
          isSubmitting={isSubmitting}
          aiStaff={aiStaff}
          onSelectCandidate={handleSelectCandidate}
          onComplete={handleComplete}
        />
        
        <NavigationButtons 
          currentStage={currentStage}
          totalStages={hiringStages.length}
          onPrevious={handlePreviousStage}
          onNext={handleNextStage}
          selectedCandidate={selectedCandidate}
        />
      </Card>
    </div>
  );
};

export default HiringProcess;
